<template>
	<div class="hiq-article-list__filters hiq-search-filters">
		<span class="show-for-sr"> Filtrera på:</span>
    <date-picker-filter></date-picker-filter>
		<tag-filter v-for="tag in tags" :key="tag.name" :tag="tag"></tag-filter>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';
import DatePickerFilter from './DatePickerFilter.vue';
import TagFilter from './TagFilter.vue';
import { ITag } from '../store/state';

interface ArticleFiltersComputed {
	articleForm: string,
	tags: ITag[],
}

export default Vue.extend<{}, {}, ArticleFiltersComputed, {}>({
	name: 'ArticleFilters',
	computed: {
		articleForm() {
			return this.$store.getters.articleForm;
		},
		tags() {
			let tagsArr =  [
				{
					name: 'Verksamhet',
					options: this.$store.getters.operations
				},
				// {
				// 	name: 'Yrkeskategori',
				// 	options: this.$store.getters.professions
				// },
				{
					name: 'Ämne',
					options: this.$store.getters.subjects
				},
				{
					name: 'Tema',
					options: this.$store.getters.themes
				}
			]

			if(this.articleForm == 'blog') {
				tagsArr.push(
					{
						name: 'Bloggnamn',
						options: this.$store.getters.blogNames
					}
				)
			}
			return tagsArr;
		}
	},
	components: {
		DatePickerFilter,
		TagFilter
	}
})
</script>
